
import { Async, Empty } from 'Core/models/Async';
import { createAction } from 'Shared/utilities/actionCreator';
import { MarketingFormStateDto } from '../models/Marketing';

export enum MarketingFormStateActionType {
  GET_MARKETING_FORM_STATES = 'marketing/GET_MARKETING_FORM_STATES',
  CHANGE_MARKETING_FORM_STATES = 'marketing/CHANGE_MARKETING_FORM_STATES',
  INVALID_MARKETING_FORM_STATES = 'marketing/INVALID_MARKETING_FORM_STATES',
}

export const getMarketingFormStates = (marketingFormState: MarketingFormStateDto) => createAction(MarketingFormStateActionType.GET_MARKETING_FORM_STATES, marketingFormState);

export const changeMarketingFormStates = (marketingFormStates: Async<MarketingFormStateDto[]>) => createAction(MarketingFormStateActionType.CHANGE_MARKETING_FORM_STATES, {marketingFormStates});

type MarketingFormStates = Async<MarketingFormStateDto[]>;

export const DEFAULT_STATE: MarketingFormStates = new Empty();


type MarketingFormStateAction =
  | ReturnType<typeof changeMarketingFormStates>
  | ReturnType<typeof getMarketingFormStates>;

export default (state: MarketingFormStates , action: MarketingFormStateAction): MarketingFormStates => {
  const currentState = state || DEFAULT_STATE;
  switch (action.type) {
    case MarketingFormStateActionType.CHANGE_MARKETING_FORM_STATES:
      return {
        ...action.payload.marketingFormStates,
      };
    default:
      return currentState;
  }
};
